/**
 * 画面の文言の見直し（UX 第2回: 台帳の詳細・数値ルール・申請・期限・体制・評価基準・設定）。i18n.ts が合成する。
 * 内部のコード・開発メモの言葉（原典・シード・知識時点など）を利用者に見せない。
 * マスタの名前（役割・申請の種類・選択肢など）は labels.ts で引く。ここは画面の枠の文言だけ。
 */
export const ja: Record<string, string> = {
  // ── 台帳の行 ──
  "reg.showBasis": "列の根拠を表示",
  "reg.basisLegend": "列名の横の札は、その列をどこから決めたかです（明記＝元の資料に書いてある／導出＝元の資料から導いた／推定＝補った）。入力する人には表示されません。",
  "reg.conf.meiki": "明記",
  "reg.conf.dou": "導出",
  "reg.conf.suitei": "推定",
  "reg.asOfHint2": "行は上書きされず、変更のたびに新しい版が残るので、申請したときの状態を後から再現できます。一覧・履歴・出力は同じ時刻までの記録で揃えて表示するので、見ている間にほかの人が追加しても表示がずれません。",

  // ── 申請 ──
  "req.conditionalParen": "（{text}）",
  "req.typeParen": "（{type}）",

  // ── ホーム ──
  "home.kind.training": "研修",
  "home.reqNo": "申請 {no}",

  // ── 期限 ──
  "obl.submitToUndecided": "提出先が決まっていません（体制で決めます）",
  "obl.submitToDecide": "体制を開く",
  "obl.sec.overdueHintViewer": "自部署の回答を求められている点検は、「部署別回答を開く」から回答してください。",

  // ── 評価基準 ──
  "cri.metWithoutEvidence": "この項目には証跡がまだありません。適合とする根拠を具体的に書くか、先に証跡を足してください。",

  // ── 数値ルール ──
  "gov.rules.detail": "詳細",
  "gov.rules.detailCode": "管理用のコード",
  "gov.rules.detailRecord": "登録時の記録",
  "gov.rules.current": "今の値: {value}",
  "gov.rules.listHint": "複数あるときは「、」で区切ってください。",

  // ── 委託先照会 ──
  "gov.vd.prioritySep": "・優先度 {p}",

  // ── 設定 ──
  "set.policySimple": "{n}文字以上にしてください。誕生日や単語そのまま、ほかのサービスと同じパスワードは使わないでください。",
};

export const en: Record<string, string> = {
  "reg.showBasis": "Show where each column comes from",
  "reg.basisLegend": "The tag next to each column shows how it was decided (Stated = written in the source material / Derived = worked out from it / Inferred = filled in). People entering data do not see these tags.",
  "reg.conf.meiki": "Stated",
  "reg.conf.dou": "Derived",
  "reg.conf.suitei": "Inferred",
  "reg.asOfHint2": "Rows are never overwritten; each change is kept as a new version, so the state at filing time can be reproduced later. The list, history and exports all show records up to the same moment, so what you see does not shift while others add entries.",

  "req.conditionalParen": " ({text})",
  "req.typeParen": " ({type})",

  "home.kind.training": "Training",
  "home.reqNo": "Request {no}",

  "obl.submitToUndecided": "No recipient decided yet (set on the Roles page)",
  "obl.submitToDecide": "Open Roles",
  "obl.sec.overdueHintViewer": "If your department has been asked to answer an inspection, answer it from “Open department responses”.",

  "cri.metWithoutEvidence": "There is no evidence for this item yet. Explain specifically why it conforms, or add evidence first.",

  "gov.rules.detail": "Details",
  "gov.rules.detailCode": "Internal code",
  "gov.rules.detailRecord": "Original record",
  "gov.rules.current": "Current value: {value}",
  "gov.rules.listHint": "Separate several items with commas.",

  "gov.vd.prioritySep": " · priority {p}",

  "set.policySimple": "Use at least {n} characters. Avoid birthdays, plain words, and passwords you use elsewhere.",
};
